export default "__VITE_ASSET__CMEmz1bR__"